// Carries a Ready vote's refund notice across the grid's page reload. The server flash alone is not enough:
// a concurrent grid request's session write can drop it.
const STORAGE_KEY = "voter-list:deactivation-notice";

export function stashDeactivationNotice(notice: unknown): void {
  if (typeof notice !== "string" || notice === "") return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path: window.location.pathname, notice }));
  } catch {
    // Storage unavailable: the server flash is still the fallback.
  }
}

export function takeDeactivationNotice(): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === null) return null;
    sessionStorage.removeItem(STORAGE_KEY);

    const { path, notice } = JSON.parse(raw) as { path?: unknown; notice?: unknown };
    return path === window.location.pathname && typeof notice === "string" ? notice : null;
  } catch {
    return null;
  }
}
